// Filter awal kalender: pilihan tersimpan ("" = sengaja direset) → komisi Ketua Komisi → semua
export const filterAwal = (user, storeKey) => {
  const tersimpan = localStorage.getItem(storeKey);
  if (tersimpan !== null) return tersimpan;
  return user?.role === "KETUA_KOMISI" && user?.komisi ? user.komisi : "";
};
